import PaginatedList from "#root/components/paginated-list";
import { billingInvoiceCollection } from "#root/schema/invoices";
import { monthNames } from "#root/utility/months";
import formatNumber from "cloudquote-number-format";
import type { JSX, ReactNode } from "react";
import { Link } from "react-router-dom";
import PageLayout from "./layout";

export default function BillingInvoicesPage(): ReactNode {
  return (
    <PageLayout title="Billing - Invoices">
      <PaginatedList title="Latest Invoices" collection={billingInvoiceCollection}>
        {({ rows }) => {
          let lastMonth: string | null = null;
          const elements: JSX.Element[] = [];

          for (const { id, date, segment, total, paid, accountName, pdfLink, iifLink } of rows) {
            const d = new Date(date);
            const month = monthNames[d.getUTCMonth()] + " " + d.getUTCFullYear();

            if (month !== lastMonth) {
              elements.push(
                <tr key={"divider-" + month}>
                  <td colSpan={6} className="label-divider">
                    {month}
                  </td>
                </tr>,
                <tr key={"header-" + month}>
                  <th>Ref</th>
                  <th>Date</th>
                  <th>Account Name</th>
                  <th>Total</th>
                  <th>Due</th>
                  <th>Edit</th>
                </tr>,
              );
              lastMonth = month;
            }

            elements.push(
              <tr key={id}>
                <td>CI-{id}</td>
                <td>{date}</td>
                <td>
                  {accountName}
                  {segment ? ` (${segment})` : ""}
                </td>
                <td>{formatNumber(Number(total), { Comma: true, Prefix: "$", Decimals: 0 })}</td>
                <td>{formatNumber(Number(total) - Number(paid), { Comma: true, Prefix: "$", Decimals: 0 })}</td>
                <td>
                  <Link to={`/billing/invoice/${id}`}>Preview Invoice</Link>&nbsp;&middot;&nbsp;
                  <a target="_blank" href={pdfLink} rel="noopener">
                    PDF Invoice
                  </a>
                  &nbsp;&middot;&nbsp;
                  <a target="_blank" href={iifLink} rel="noopener">
                    IIF
                  </a>
                  &nbsp;&middot;&nbsp;
                  <Link to={`/billing/invoice/${id}/edit`}>Edit</Link>&nbsp;&middot;&nbsp;
                  <Link to={`/billing/invoice/${id}/clone`}>Clone</Link>
                </td>
              </tr>,
            );
          }

          return (
            <table>
              <tbody>{elements}</tbody>
            </table>
          );
        }}
      </PaginatedList>
    </PageLayout>
  );
}
